// An ore-bearing rock: a grey boulder with dark metallic iron chunks embedded
// in its faces. Ported 1:1 from age-of-mcp's classic ore-rock.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.34, 0), color: "#787b82",
      position: [0, 0.24, 0], scale: [1.1, 0.95, 1] },
    // ore veins — dark metallic facets
    { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#4a4f57",
      position: [0.16, 0.3, 0.14] },
    { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: "#5a5048",
      position: [-0.14, 0.22, 0.16] },
    { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#3f444b",
      position: [0.04, 0.36, -0.14] },
  ];
}

export const oreRock = defineModel({
  id: "ore-rock",
  batchId: "standard",
  name: "Ore rock",
  tags: ["scenery","ore","rock","low-poly","age-of-mcp","classic"],
  summary: "Low-poly ore rock.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => partsFor(),
  animations: [],
});
